// FILE: src/components/support/ticketDisplay.jsx
// Shared pieces for the student's support pages (WP-8): status and
// category chips (icon + words, never colour alone — MTO 5.4), the
// category icons, en-CA dates, and a short title from the student's text.
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { StatusChip } from "../ui";
import { ticketCategoryLabel, ticketStatusLabel } from "../../i18n/labels";

export const TICKET_CATEGORIES = ["TECHNICAL", "SERVICE", "CONTENT"];
export const TICKET_STATUSES = ["OPEN", "RESOLVED"];

export const CATEGORY_ICONS = {
  TECHNICAL: ComputerOutlinedIcon,
  SERVICE: BadgeOutlinedIcon,
  CONTENT: MenuBookOutlinedIcon
};

export function categoryIcon(category) {
  return CATEGORY_ICONS[category] || HelpOutlineIcon;
}

const STATUS_STYLE = {
  OPEN: { tone: "info", Icon: ScheduleOutlinedIcon },
  IN_PROGRESS: { tone: "warning", Icon: AutorenewOutlinedIcon },
  RESOLVED: { tone: "success", Icon: CheckCircleOutlineIcon }
};

export function TicketStatusChip({ status, size = "small" }) {
  const { tone, Icon } = STATUS_STYLE[status] || { tone: "default", Icon: HelpOutlineIcon };
  return <StatusChip label={ticketStatusLabel(status)} tone={tone} icon={<Icon aria-hidden />} size={size} />;
}

export function CategoryChip({ category, size = "small" }) {
  const Icon = categoryIcon(category);
  return <StatusChip label={ticketCategoryLabel(category)} tone="default" icon={<Icon aria-hidden />} size={size} />;
}

function toDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "Oct 7, 2026" */
export function formatDate(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" }) : "—";
}

/** "Oct 7, 2026, 10:42 a.m." */
export function formatDateTime(value) {
  const d = toDate(value);
  return d
    ? d.toLocaleString("en-CA", { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
    : "—";
}

/** A short title for a request: the first line of what the student wrote. */
export function ticketTitle(ticket, max = 90) {
  const first = String(ticket?.description || "")
    .split(/\r?\n/)
    .map((l) => l.trim())
    .find(Boolean);
  if (!first) return `${ticketCategoryLabel(ticket?.category)} request`;
  return first.length > max ? `${first.slice(0, max - 1).trimEnd()}…` : first;
}
